// extracted by mini-css-extract-plugin
module.exports = {"headerTitleH1":"HeaderTitleH1_headerTitleH1__FSrQM","title":"HeaderTitleH1_title__jGsUl","fontsizeOverflowing":"HeaderTitleH1_fontsizeOverflowing__J0YgH"};